import {Interval} from 'luxon';

import {computeIsValidInterval} from '../../../../../libs/shared/core/src/helpers/datetime/luxonHelpers';
import {
  buildIntervalFromStandardAvailabilityBlock,
  buildStandardAvailabilityBlockFromInterval,
} from '../../../../helpers/models/schedulingLinkAvailabilityHelpers';
import {SchedulingLinkStandardAvailabilityBlockModel} from '../../../../models/api/schedulingLinkModel';

/*
 * Api.
 */

export function addStandardAvailabilityBlock(
  selectedBlocks: ReadonlyArray<SchedulingLinkStandardAvailabilityBlockModel>,
  slot: SchedulingLinkStandardAvailabilityBlockModel,
  durationMinutes: number,
): ReadonlyArray<SchedulingLinkStandardAvailabilityBlockModel> {
  const blockToAdd = expandSlotToDuration(slot, durationMinutes);
  const unmergedBlocks = [...selectedBlocks, blockToAdd];

  // Merge blocks.
  const availabilityBlocks = Interval.merge(unmergedBlocks.map(buildIntervalFromStandardAvailabilityBlock))
    .filter(computeIsValidInterval)
    .map(buildStandardAvailabilityBlockFromInterval);

  return availabilityBlocks;
}

export function removeStandardAvailabilityBlock(
  selectedBlocks: ReadonlyArray<SchedulingLinkStandardAvailabilityBlockModel>,
  slot: SchedulingLinkStandardAvailabilityBlockModel,
): ReadonlyArray<SchedulingLinkStandardAvailabilityBlockModel> {
  return selectedBlocks.filter((s) => s !== slot);
}

export function updateStandardAvailabilityBlock(
  selectedBlocks: ReadonlyArray<SchedulingLinkStandardAvailabilityBlockModel>,
  oldSlot: SchedulingLinkStandardAvailabilityBlockModel,
  newSlot: SchedulingLinkStandardAvailabilityBlockModel,
  durationMinutes: number,
): ReadonlyArray<SchedulingLinkStandardAvailabilityBlockModel> {
  const selectedBlocksWithoutOld = removeStandardAvailabilityBlock(selectedBlocks, oldSlot);
  const selectedBlocksWithNew = addStandardAvailabilityBlock(
    selectedBlocksWithoutOld,
    newSlot,
    durationMinutes,
  );
  return selectedBlocksWithNew;
}

/*
 * Helpers.
 */

function expandSlotToDuration(
  slot: SchedulingLinkStandardAvailabilityBlockModel,
  durationMinutes: number,
): SchedulingLinkStandardAvailabilityBlockModel {
  return {
    ...slot,
    end: Math.max(slot.start + durationMinutes * 60 * 1000, slot.end),
  };
}
